import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen, useUk } from '../../../../../hooks'
import { DatePicker } from '../../../../DateTime'
import { FormField } from '../../../../Form'
import {
  CONTRACT_DEFAULT_EVICTION_DELAY_DAYS,
  CONTRACT_FORM_FIELD_NAME_END_DATE,
} from '../../../Contract.constants'
import { getContractDisplayedDelayedDate } from '../../ContractForm.utils'

function DelayedDateField({ delayedDate }) {
  const { t } = useTranslation()

  const { initialValues, values } = useFormikContext()

  const { isMobileScreenSize } = useScreen()

  const { config } = useUk()

  const evictionDelay =
    config.eviction_delay ?? CONTRACT_DEFAULT_EVICTION_DELAY_DAYS

  const displayedDelayedDate = getContractDisplayedDelayedDate({
    delayedDate,
    endDate: values[CONTRACT_FORM_FIELD_NAME_END_DATE],
    evictionDelay,
    initialEndDate: initialValues[CONTRACT_FORM_FIELD_NAME_END_DATE],
  })

  return (
    <FormField
      disabled
      shouldAdaptToMobileScreen
      info={t('Contract.DelayedDateInfoTooltipKey', { days: evictionDelay })}
      label={`${t('Contract.DelayedDateLabelKey')}:`}
    >
      <DatePicker
        disabled
        borderless={!isMobileScreenSize}
        placeholder={t('Contract.DatePlaceholderKey')}
        value={displayedDelayedDate}
      />
    </FormField>
  )
}

export default DelayedDateField
